import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="min-h-screen w-full flex">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
